import type {TranslatedText} from "@/types/translations";
export interface TranslationModalData {id: string; translations: TranslatedText[]; isTextArea: boolean; isOptional: boolean}
import {defineStore} from "pinia";

export const useTranslationModal = defineStore('translationModal', {
    persist: true,

    state: () => ({
        visible: false,
        data: null as TranslationModalData | null,
        listeners: {} as Record<string, (data: TranslationModalData) => void>,
    }),

    actions: {
        open(data: TranslationModalData) {
            this.data = data;
            this.visible = true;
        },

        close() {
            this.visible = false;
            this.data = null;
        },

        registerListener(id: string, callback: (data: TranslationModalData) => void) {
            this.listeners[id] = callback;
        },

        commit() {
            const id = this.data?.id;
            const cb = this.listeners?.[id!];
            if (typeof cb === 'function') {
                cb(this.data!);
                delete this.listeners[id!];
            }
        }
    }
});